export const buildStateLandingWebPageSchema = ({
	title,
	description,
	canonicalUrl,
	stateName
}) => ({
	"@context": "https://schema.org",
	"@type": "WebPage",
	name: title,
	url: canonicalUrl,
	description,
	mainEntity: {
		"@type": "Place",
		name: stateName
	}
});

export const buildStateLandingWebSiteSchema = ({ stateName, baseUrl }) => ({
	"@context": "https://schema.org",
	"@type": "WebSite",
	name: "Storage.com",
	url: `${baseUrl}/`,
	potentialAction: {
		"@type": "SearchAction",
		target: {
			"@type": "EntryPoint",
			urlTemplate: `${baseUrl}/search?location={search_term_string}%2C%20USA`,
			inLanguage: "en-US",
			actionPlatform: [
				"https://schema.org/DesktopWebPlatform",
				"https://schema.org/MobileWebPlatform"
			]
		},
		"query-input": {
			"@type": "PropertyValueSpecification",
			valueRequired: true,
			valueName: "search_term_string",
			valuePattern: stateName
		}
	}
});

export const buildStateLandingBreadcrumbSchema = ({
	title,
	canonicalUrl,
	baseUrl
}) => ({
	"@context": "https://schema.org",
	"@type": "BreadcrumbList",
	itemListElement: [
		{
			"@type": "ListItem",
			position: 1,
			name: "Home",
			item: `${baseUrl}/`
		},
		{
			"@type": "ListItem",
			position: 2,
			name: title,
			item: canonicalUrl
		}
	]
});
